module.exports = __webpack_public_path__ + "img/ZonePlaceholder.ecda499b.png";